const index = () => import('./index')

export default [
  {
    path: '/assignment_requests',
    name: 'assignment_requests.index',
    component: index,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/assignment_request/routes.js